module.exports = __webpack_public_path__ + "img/login-side.64d81705.png";